import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefConditionCustomizeDomesticNsc = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      colId: 'isApplied',
      headerName: '',
      headerTooltip: t('grid.apply'),
      cellRenderer: 'selectConditionCustomizeRenderer',
      minWidth: 50,
      maxWidth: 50,
    },
    {
      field: 'customer1',
      headerName: t('condition.customer1'),
      headerTooltip: t('condition.customer1'),
      width: 75,
    },
    {
      field: 'customer1Name',
      headerName: t('condition.customerName1'),
      headerTooltip: t('condition.customerName1'),
      tooltipField: 'customer1Name',
      width: 150,
    },
    {
      field: 'customer2',
      headerName: t('condition.customer2'),
      headerTooltip: t('condition.customer2'),
      width: 75,
    },
    {
      field: 'customer2Name',
      headerName: t('condition.customerName2'),
      headerTooltip: t('condition.customerName2'),
      tooltipField: 'customer2Name',
      width: 150,
    },
    {
      field: 'customer3',
      headerName: t('condition.customer3'),
      headerTooltip: t('condition.customer3'),
      width: 75,
    },
    {
      field: 'customer3Name',
      headerName: t('condition.customerName3'),
      headerTooltip: t('condition.customerName3'),
      tooltipField: 'customer3Name',
      width: 150,
    },
    {
      field: 'deliveryLocation',
      headerName: t('deliveryLocation.deliveryLocation'),
      headerTooltip: t('deliveryLocation.deliveryLocation'),
      width: 80,
    },
    {
      field: 'deliveryLocationName',
      headerName: t('deliveryLocation.deliveryLocationName'),
      headerTooltip: t('deliveryLocation.deliveryLocationName'),
      tooltipField: 'deliveryLocationName',
      width: 150,
    },
    {
      field: 'standard',
      headerName: t('millSheet.standard'),
      headerTooltip: t('millSheet.standard'),
      tooltipField: 'standard',
      width: 140,
    },
    {
      field: 'sizeDisplay',
      headerName: t('millSheet.size'),
      headerTooltip: t('millSheet.size'),
      width: 60,
    },
  ];

  return colDefs;
};

export default useColdefConditionCustomizeDomesticNsc;
